export default {
  TITLE: '500',
  SUBTITLE: 'Nós temos um problema. =(',
  DESCRIPTION: 'A página está temporariamente indisponível.',
};
